<template>
	<div>	
		<v-row class="mt-3">
			<v-col>
				<h3>
					{{ displayName }}
					<v-btn link icon v-if="view == 'admin'" :to="{name: 'edit', params: { type: 'participants', id: participant.id } }"><v-icon>mdi-link</v-icon></v-btn>
					<span style="font-size: 12px; font-weight: normal; float: right; line-height: 40px;"><a v-if="view=='admin'" color="primary" text link v-bind:href="'/edit/appointments/' + appointment.id" target="blank" class="mr-2">Edit Appointment</a></span>
				</h3> 
				<p v-if="project" class="mw-h3 mb-3">
					<span> {{project.clientName}}   </span>
					<v-btn  v-if="view == 'client'"  link icon :to="{name: 'viewObject', params: { type: 'projects', id: appointment.project } }"><v-icon>mdi-link</v-icon></v-btn>
					<v-btn  v-if="view == 'admin'"  link icon :to="{name: 'edit', params: { type: 'projects', id: appointment.project } }"><v-icon>mdi-link</v-icon></v-btn>
				</p>

				<p class="subtitle-2 mt-3">{{ localAppointmentTimeString }} ({{userTimezone}})</p>
			</v-col>
			<v-col v-if="appointment.status" cols="6" md="3" class="text-right">
				<v-chip class="ma-2" :color="statusColor(appointment.status)" text-color="white"> {{prettyPrint(appointment.status, "TITLE")}}</v-chip>
			</v-col>
		</v-row>
		<v-simple-table class="mb-2">
			<tbody>
				<tr v-if="appointment.quota">
					<td width="20%"><b>Quota</b></td>
					<td>{{prettyPrint(appointment.quota, "TITLE")}}</td>
				</tr>
				<template v-if="appointment.additionalFields">
				<tr v-for="(field, i) in project.additionalFields" :key="i">
					<td><b>{{prettyPrint(field, "TITLE")}}:</b></td>
					<td>{{prettyPrint(appointment.additionalFields[field], "TITLE")}}</td>
				</tr>
				</template>
			</tbody>	
		</v-simple-table>
			
		<div class="text-right">
			<div v-if="displayComms">
				<v-dialog v-model="showStartVideo" width="600">
					<template v-slot:activator="{ on }">
						<v-btn v-if="appointment.methodology == 'video' && project.includeVideoCalling" v-on="on" class="mr-2"  x-large color="green" dark @click="showStartVideo = 1">Start Video Conference</v-btn>
					</template>
					<StartVideo :appointment="appointment"></StartVideo>
				</v-dialog>

				<v-dialog v-model="showSendMessage" width="600">
					<template v-slot:activator="{ on }">
						<v-btn x-large color="primary" dark @click="showSendMessage = 1" class="mr-2"  v-on="on" >Send Message</v-btn>	
					</template>
					<SendCustomMessage 
					:anonymous="view == 'client'"
					:templateMessagingParams="templateMessagingParams"
					:to="[appointment.participant]" 
					:from="user.uid"
					v-on:cancel="showSendMessage = 0"
					v-on:sent="messageSent"
					></SendCustomMessage>
				</v-dialog>

				<v-dialog v-model="showStartPhone" width="400">
					<template v-slot:activator="{ on }">
						<v-btn  v-if="appointment.methodology == 'phone' && project.includeCalling" class="mr-2"  v-on="on"  x-large  color="green" dark>Start Call</v-btn>
					</template>
					<StartPhone :appointment="appointment"></StartPhone>
				</v-dialog>
				<v-dialog v-model="showRecordings" width="1000">
					<template v-slot:activator="{ on }">
						<v-btn v-if="appointment.methodology == 'video'" v-on="on"  x-large  color="accent" dark>Recordings</v-btn>
					</template>
					<Recordings :appointment="appointment"></Recordings>
				</v-dialog>
			</div>
			
		</div>
		<v-snackbar v-model="showMessageSent" light>
			{{messageFeedback}}
		<v-btn color="accent" text @click="showMessageSent = false">Close </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	import Vuex from 'vuex';
	import {localDateTimeString, userTimezone} from "../../assets/timezoneFunctions.js"
	import SendCustomMessage from "../tools/SendCustomMessage.vue";
	import {visibleDisplayName, allowComms} from "../../assets/permissionsFunctions.js"
	import StartVideo from "../communication/video/StartVideo";
	import StartPhone from "../communication/video/StartPhone";
	import Recordings from "../communication/video/Recordings.vue"

	import {prettyPrint, statusColor} from "../../assets/utilities.js";
	export default{
		name: "ViewAppointment", 
		data: () => {
			return {
				showStartVideo: 0,
				showStartPhone: 0,
				showSendMessage: 0,
				showMessageSent: 0,
				showRecordings: 0,
				messageFeedback: 'Message sent'
			}
		},
		props: {
			appointment: {type: Object },
		}, 	
		components:{
			StartVideo: StartVideo,
			StartPhone: StartPhone,
			Recordings: Recordings,
			SendCustomMessage: SendCustomMessage
		},
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				user: state => state.auth.user,
				userInfo: state => state[state.auth.view].user,
				project: function(state){
					let aId = this.appointment.project;
					return state[state.auth.view].projects.find( p => p.id == aId )
				},
				participant: function(state){
					let aId = this.appointment.participant;
					return state[state.auth.view].panelists.find( p => p.id == aId )
				},
				templateMessagingParams() {
					return {
						project: this.appointment.project,
						appointments: [
							{
								appointment: this.appointment.id,
								project: this.appointment.project, 
								recipient: this.appointment.participant 
							}
						]
					}
				}
			}),
			displayName(){
				return visibleDisplayName(this.user, this.participant, this.project)
			}, 
			displayComms(){
				return allowComms( this.user, this.project )
			},
			userTimezone() {
				return userTimezone(this.userInfo)
			},
			localAppointmentTimeString(){
				if( !this.appointment.dateTime ){ return ""; }
				return localDateTimeString(this.userInfo, this.appointment.dateTime.toDate(), "LONG" )
			},
		},
		methods: {
			prettyPrint: prettyPrint,
			statusColor: statusColor,
			messageSent(message){
				this.messageFeedback = message;
				this.showSendMessage = 0;
				this.showMessageSent = 1;

			}
		}

	}
</script>